import { useEffect, useState } from 'react'; 
import PageTooltip from './PageTooltip';
import pencilIcon from '../../svgs/pencil-icon.svg';
import pencilIconDisabled from '../../svgs/pencil-icon-disabled.svg';

const RowEditIcon = ({ enable, onClick, icon, tooltip, disabledTooltip }) => {
    // initialize state 
    const [editIcon, setEditIcon] = useState(pencilIcon); 
    const [editTooltip, setEditTooltip] = useState('edit'); 

    useEffect(() => {
        if (icon) {
            setEditIcon(editIcon => editIcon = icon); 
        }
        else {
            setEditIcon(editIcon => editIcon = pencilIcon); 
        }
        
    }, [icon]); 

    useEffect(() => {
        if (tooltip) {
            setEditTooltip(editTooltip => editTooltip = tooltip); 
        }
        else {
            setEditTooltip(editTooltip => editTooltip = 'edit'); 
        }
    }, [tooltip]);     

    return (
        <>
            { enable ? 
            <>
                {/* show edit icon to trigger edit modal */}
                <PageTooltip title={editTooltip}>
                    <img src={editIcon} className='data-table-icon' onClick={(e)=>onClick(e)}/>
                </PageTooltip>
            </>
            : disabledTooltip ?
            <>
                {/* show disabled pencil icon with tooltip when a pending workflow exists */}
                <PageTooltip title={disabledTooltip}>
                    <img src={pencilIconDisabled} className='data-table-icon' style={{ cursor: 'not-allowed', opacity: 0.5 }}/>
                </PageTooltip>
            </>
            :<></>}
        </>
    );
}

export default RowEditIcon;